import { Component, OnInit } from '@angular/core';

import { ROUTE_ANIMATIONS_ELEMENTS } from '@app/core';

@Component({
  selector: 'lamentaliste-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  //releaseButler = require('../../../assets/release-butler.png');

  clickMessage = 'BIP !';

  constructor() {}

  ngOnInit() {}

  onClickMe() {
    this.clickMessage = 'You are my hero!';
  }
}
